<template>
  <div class="background-03">
    <v-container class="" pb-5>
      <v-layout row wrap justify-center mt-5>
        <v-flex xs12 sm3 md2 lg1>
          <image-app :imaSize="80" imaSrc="design/banco3-1-1" imaAlt=""></image-app>
        </v-flex>
        <v-flex xs12 sm9 md8 lg8>
          <h1 class="animated fadeInLeft">
            <span class="davi-curs font-red">
              En resumen,
            </span>
            el patrimonio se puede definir en la siguiente fórmula:
          </h1>
          <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Fórmula del patrimonio'" videoEmbed="ADMINISTRACIONDINERO47FormulaPatrimonio.mp4"></ui-simple-lsc>
      </v-flex>
      </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mt-2 class="animated fadeInUp dura_1">
        <v-flex xs12 sm10 md10 text-xs-center>
          <p class="formula-patrimonio">
            <span class="font-red davi-curs">Patrimonio =</span>
             Propiedades +
             <span class="font-red davi-curs">
               <tooltip class="tip font-red davi-curs" texto="ingresos" tooltip="Es el dinero que se destina para comprar algo que genere ingresos futuros. Es un plan en el que se trazan objetivos económicos y se eligen formas de inversión (negocios, bienes raíces, etc.) para alcanzarlos, así como estrategias de protección o cubrimiento de riesgos, especialmente aquellos relacionados con la persona que ejecuta el plan." textPos="text-right"></tooltip>
             </span>
              + Ahorro <span class="font-red">– Deudas</span>
          </p>
        </v-flex>
      </v-layout>
      <v-layout v-if="inversion" row wrap justify-center class="adorn-bottom animated fadeInDown light-dark-int ">
        <v-flex  xs12 sm10 md7>
          <p role="alert">
            Es el dinero que se destina para comprar algo que genere ingresos futuros. <br><br>
            Es un plan en el que se trazan objetivos económicos y se eligen formas de inversión
            (negocios, bienes raíces, etc.) para alcanzarlos, así como estrategias de protección o
            cubrimiento de riesgos, especialmente aquellos relacionados con la persona que ejecuta el plan.
          </p>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inversion: false,
    };
  },
  methods: {
    botClick(){
      this.inversion = true;
      this.$store.commit("nextShow", true);
    }
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>

<style lang="scss" scoped>
@import '../../../sass/helpers/mixins.scss';
@import '../../../sass/helpers/variables.scss';
.formula-patrimonio{
  font-weight: bold;
  font-size: 25px;
}
.inver-bot{
  border: solid 1px $primary-red;
  border-radius: 5px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// davivienda-47.vue?503b95dc